import { Injectable } from "@angular/core";
import { AppConifg } from "../app-shared/model/app-config";
import { AppMessageService } from "./app-message.service";
import { AppMessageConstant } from "../app-shared/app-message-constant";
import { ZzUser } from "../zz/zz-user/shared/zz-user.model";
import { ZzMenuTree } from "../zz/zz-menu/shared/zz-menu";
import { SdSprMasterData } from "../sd-spr/shared/sd-spr";

@Injectable({providedIn:'root'})
export class AppConfigDataService{
  readonly appConifg = 'appConfig';
  readonly mtrItems = 'mtrItems';
  readonly currentUser = 'currentUser';
  readonly menusAll = 'menusAll';
  readonly menuTitle = '';
  constructor(private msgService: AppMessageService){}
  saveConfigAll(currentUser?: ZzUser, appConfig?: AppConifg){
    if (!currentUser || !appConfig){
      this.msgService.add(AppMessageConstant.get_config_error);
      this.clearConfigAll();
      return;
    }
    //AppConfig
    if (currentUser){
      localStorage.setItem(this.currentUser,JSON.stringify(currentUser));

    }
    if (appConfig){
      localStorage.setItem(this.appConifg,JSON.stringify(appConfig));
    }

  }
  clearConfigAll(){
    localStorage.removeItem(this.appConifg)
    localStorage.removeItem(this.mtrItems);
    localStorage.removeItem(this.currentUser);
    localStorage.removeItem(this.menusAll);
  }

  //Get
  getAppConfig(): AppConifg{
    return JSON.parse(localStorage.getItem(this.appConifg)!);
  }
  getUserMenus(): ZzMenuTree[]{
    return JSON.parse(localStorage.getItem(this.mtrItems)!);
  }
  getCurrentUser(): ZzUser{
    return JSON.parse(localStorage.getItem(this.currentUser)!);
  }
  
  getSprMasterData(): SdSprMasterData{
    var config = this.getAppConfig();
    var item: SdSprMasterData = {
      qty_up_per: config.qty_up_percent,
      qty_down_per: config.qty_down_percent
    };
    return item;
  }
}
